import { render } from "./ItemVariantView.vue?vue&type=template&id=2784ee96"
import script from "./ItemVariantView.vue?vue&type=script&lang=js"
export * from "./ItemVariantView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__